<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >

    <FormItem label="所属分类"  prop="classify_id"  v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="用户名" prop="username">
        <Input v-model="formValidate.username" placeholder="请输入名称"></Input>
      </FormItem>

      <FormItem label="首页链接" prop="home_url">
        <Input v-model="formValidate.home_url" placeholder="请输入首页链接"></Input>
      </FormItem>

      <FormItem label="所属平台" prop="live_id" >
          <Select v-model="formValidate.live_id" clearable>
            <Option
              v-for="item in liveTypes"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem>

      <FormItem label="是否是立即发布">
        <RadioGroup v-model="formValidate.push" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </FormItem>


        <FormItem label="运营账号" >
          <Transfer
            :list-style="listStyle"
            :titles="['未选', '已选']"
            :data="userIds"
            :target-keys="formValidate.users"
            filterable
            :filter-method="filterMethod"
            @on-change="handleChange"
          ></Transfer>
      </FormItem>

        <FormItem style="text-align: right">
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>

    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import {getStandUser, addStandUser, deleteStandUser} from "@/api/data";
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listStyle:{
        width: '200px'
      },
      classifyIds: [],
      tagIds:[],
      liveTypes:[],
      userClassifyIds:[],
      shortVideoClassifyIds:[],
      userIds:[],
      formValidate: {
        id: '',
        username:'',
        home_url:'',
        live_id:'',
        users:[],
        classify_id:'',
        push:'否'
      },
      ruleValidate: {
       home_url: [
          {
            required: true,
            message: '首页链接必须填写',
            trigger: 'blur'
          }
        ],   
        username: [
          {
            required: true,
            message: '用户名必须填写',
            trigger: 'blur'
          }
        ],   
        live_id: [
          {
            required: true,
            message: '平台必须选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },
    handleChange (newTargetKeys) {
      this.formValidate.users = newTargetKeys
    },
    setLiveType (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.liveTypes = data
    },
    setUsers(users){
      var data = new Array()
      for (var i = 0; i < users.length; i++) {
        var user = users[i]
        if (!user._black){
          data.push({key: user.id, label: user.username})
        }
      }
      this.userIds = data
    },
    setEditData(params){
      this.formValidate.id = params.id
      this.formValidate.username = params.username
      this.formValidate.home_url = params.home_url
      this.formValidate.live_id = params.live_id.toString()
      this.formValidate.classify_id = params.classify_id.toString()
      this.formValidate.push = params.push?"是":"否"

      var users = params.list
      var data = []
      for (var i = 0; i < users.length; i++) {
        data.push(users[i].id)
      }
      this.formValidate.users = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
